import { useState } from "react";
import { useSupportMode } from "@/lib/support-mode";
import { Button } from "@/components/ui/button";
import { Eye, LogOut, Loader2 } from "lucide-react";

export function SupportModeBanner() {
  const { active, workspaceName, exitSupportMode } = useSupportMode();
  const [exiting, setExiting] = useState(false);

  if (!active) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitSupportMode();
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      className="relative flex items-center justify-between gap-2 sm:gap-3 px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm bg-amber-500 text-amber-950 border-b border-amber-600"
      data-testid="banner-support-mode"
    >
      <div className="flex items-center gap-1.5 sm:gap-2 min-w-0">
        <Eye className="h-3.5 w-3.5 shrink-0" />
        <span className="truncate font-medium" data-testid="text-support-mode-org">
          Support Mode — Viewing {workspaceName}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-6 sm:h-7 text-[10px] sm:text-xs px-2 sm:px-3 bg-amber-950/10 border-amber-950/20 text-amber-950 hover:bg-amber-950/20 hover:text-amber-950"
        onClick={handleExit}
        disabled={exiting}
        data-testid="button-exit-support-mode"
      >
        {exiting ? (
          <Loader2 className="mr-1 h-3 w-3 animate-spin" />
        ) : (
          <LogOut className="mr-1 h-3 w-3" />
        )}
        Exit
      </Button>
    </div>
  );
}
